// extracted by mini-css-extract-plugin
export default {"houseSize":"50"};